import type { FaqEntry } from '@/content/faq';

function Chevron() {
  return (
    <svg className="cv" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} aria-hidden>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

/**
 * Perguntas frequentes com o mesmo visual da página de Preços.
 *
 * `<details>` abertos no HTML gerado: a resposta fica visível sem clique e sem
 * JavaScript, que é a condição para o Google aceitar o `FAQPage` da rota.
 */
export function FaqList({ entries }: { entries: FaqEntry[] }) {
  return (
    <div className="faq-wrap rev">
      {entries.map((entry) => (
        <details className="faq-i" key={entry.question} open>
          <summary>
            {entry.question}
            <Chevron />
          </summary>
          <div className="fa">{entry.answer}</div>
        </details>
      ))}
    </div>
  );
}
